import { render, staticRenderFns } from "./cs.vue?vue&type=template&id=15f1561d&scoped=true&"
var script = {}
import style0 from "./cs.vue?vue&type=style&index=0&id=15f1561d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f1561d",
  null
  
)

export default component.exports